/* PS. Superstore theme v9.2 — vanilla JS, no framework.
   1. Shared rotation clock (homepage hero, collection hero, brands panel)
   2. Nav hover preview (pauses the clock while open)
   3. Cart drawer (Ajax Cart API + Section Rendering API)
   4. Product form (variant selection, size validation, qty, add to cart)
   5. Collection load more, filter drawer, sort
   6. Newsletter form
*/
(function () {
  'use strict';
  var PS = window.PS || {};
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ------------------------------------------------------------------
     1. Shared rotation clock
     One setInterval increments a global index. Every rotator derives its
     slide from index % slides.length. Paused while a nav preview is open.
  ------------------------------------------------------------------ */
  var clock = { index: 0, holds: 0, timer: null, stopped: false, rotators: [] };

  function paint() {
    clock.rotators.forEach(function (r) {
      var slides = r.slides;
      if (!slides.length) return;
      var i = ((r.offset + clock.index) % slides.length + slides.length) % slides.length;
      if (r.current === i) return;
      r.current = i;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        // Inactive slides are only opacity:0, so without this their links stay tabbable.
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); }
        else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      if (r.dots) r.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (r.onChange) r.onChange(i);
    });
  }

  var ICON_PAUSE = '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>';
  var ICON_PLAY = '<path d="M8 5l11 7-11 7z"/>';

  // Paints a rotate toggle: accessible name, pressed state and the glyph, together.
  // stopped === true means the slideshow is paused, so the control offers Play.
  function setToggle(btn, stopped) {
    btn.setAttribute('aria-pressed', stopped ? 'true' : 'false');
    btn.setAttribute('aria-label', btn.getAttribute(stopped ? 'data-label-play' : 'data-label-pause') || (stopped ? 'Play slideshow' : 'Pause slideshow'));
    var svg = btn.querySelector('svg');
    if (svg) svg.innerHTML = stopped ? ICON_PLAY : ICON_PAUSE;
  }

  function registerRotator(root) {
    if (root.getAttribute('data-rotator-ready')) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (!slides.length) return;
    root.setAttribute('data-rotator-ready', '1');
    var r = { root: root, slides: slides, offset: 0, current: -1,
      dots: Array.prototype.slice.call(root.querySelectorAll('[data-dot]')),
      onChange: null };
    // Collection heroes and brand panels show a caption for the current slide.
    var caps = Array.prototype.slice.call(root.querySelectorAll('[data-caption]'));
    if (caps.length) {
      r.onChange = function (i) { caps.forEach(function (c, k) { c.hidden = k !== i; }); };
    }
    r.dots.forEach(function (d, k) {
      d.addEventListener('click', function () {
        // Jump: shift this rotator's offset so index maps to k, keep the clock shared.
        r.offset = ((k - clock.index) % slides.length + slides.length) % slides.length;
        paint();
        r.dots.forEach(function (x, j) { x.setAttribute('aria-current', j === k ? 'true' : 'false'); });
        // paint() may have made the slide holding focus inert, which blurs it.
        if (document.activeElement === document.body || !document.activeElement) d.focus();
      });
    });
    // SC 2.2.2: auto-rotation must be pausable. Hover and keyboard focus hold the
    // clock, and the section can render a [data-rotate-toggle] button that stops it.
    var hovering = false, focused = false;
    root.addEventListener('mouseenter', function () { if (hovering) return; hovering = true; hold(); });
    root.addEventListener('mouseleave', function () { if (!hovering) return; hovering = false; release(); });
    // focusin bubbles, so guard on entry: without this every Tab inside the rotator
    // adds a hold that focusout never returns, and the clock stops for good.
    root.addEventListener('focusin', function () { if (focused) return; focused = true; hold(); });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      if (!focused) return;
      focused = false; release();
    });
    var toggle = root.querySelector('[data-rotate-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (clock.stopped) {
          clock.stopped = false;
          startClock();
        } else {
          clock.stopped = true;
          if (clock.timer) { clearInterval(clock.timer); clock.timer = null; }
        }
        // One clock, so every toggle on the page reports the same state.
        document.querySelectorAll('[data-rotate-toggle]').forEach(function (t) { setToggle(t, clock.stopped); });
      });
      if (reduce) {
        clock.stopped = true;
        setToggle(toggle, true);
      }
    }
    clock.rotators.push(r);
  }

  function startClock() {
    if (clock.timer || reduce || clock.stopped) return;
    clock.timer = setInterval(function () {
      if (clock.holds > 0 || document.hidden) return;
      clock.index += 1;
      paint();
    }, PS.rotateMs || 5200);
  }
  function hold() { clock.holds += 1; document.documentElement.classList.add('is-holding'); }
  function release() { clock.holds = Math.max(0, clock.holds - 1); if (!clock.holds) document.documentElement.classList.remove('is-holding'); }

  /* ------------------------------------------------------------------
     2. Nav hover preview
  ------------------------------------------------------------------ */
  function initNav() {
    var items = document.querySelectorAll('[data-nav-item]');
    items.forEach(function (item) {
      if (item.getAttribute('data-nav-ready')) return;
      item.setAttribute('data-nav-ready', '1');
      var open = false;
      function show() { if (open) return; open = true; item.classList.add('is-open'); hold(); }
      function hide() { if (!open) return; open = false; item.classList.remove('is-open'); release(); }
      item.addEventListener('mouseenter', show);
      item.addEventListener('mouseleave', hide);
      item.addEventListener('focusin', show);
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) hide(); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); var t = item.querySelector('[data-nav-top]'); if (t) t.focus(); } });
    });

    // Mobile menu
    var mnav = document.querySelector('[data-mnav]');
    if (mnav && !mnav.getAttribute('data-mnav-ready')) {
      mnav.setAttribute('data-mnav-ready', '1');
      var mnavLast = null, mnavRelease = null;
      var openM = function () {
        mnavLast = document.activeElement;
        mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        mnavRelease = trapFocus(mnav);
        var c = mnav.querySelector('[data-mnav-close]'); if (c) c.focus();
      };
      var closeM = function () {
        mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (mnavRelease) { mnavRelease(); mnavRelease = null; }
        if (mnavLast && mnavLast.focus) mnavLast.focus();
        mnavLast = null;
      };
      document.querySelectorAll('[data-mnav-open]').forEach(function (b) { b.addEventListener('click', openM); });
      mnav.querySelectorAll('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', closeM); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mnav.classList.contains('is-open')) closeM(); });
    }
  }

  /* ------------------------------------------------------------------
     3. Cart drawer
  ------------------------------------------------------------------ */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  // aria-modal="true" tells assistive tech the rest of the page is unreachable, so
  // Tab has to be contained for real. Returns a function that removes the handler.
  function trapFocus(container) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        container.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  var drawer = {
    el: null,
    lastFocus: null,
    releaseTrap: null,
    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.releaseTrap = trapFocus(this.el);
      var c = this.el.querySelector('[data-drawer-close]'); if (c) c.focus();
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.releaseTrap) { this.releaseTrap(); this.releaseTrap = null; }
      // SC 2.4.3: focus goes back to whatever opened the drawer.
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      this.lastFocus = null;
    },
    refresh: function () {
      var self = this;
      return fetch((PS.routes.root || '/') + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json['cart-drawer'];
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-drawer]');
          if (fresh && self.el) {
            var wasOpen = self.el.classList.contains('is-open');
            self.el.innerHTML = fresh.innerHTML;
            if (wasOpen) self.el.classList.add('is-open');
            self.bind();
          }
          var count = tmp.querySelector('[data-drawer-count]');
          if (count) updateCounts(count.textContent.trim());
        });
    },
    bind: function () {
      var self = this;
      if (!self.el) return;
      self.el.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      self.el.querySelectorAll('[data-line-remove]').forEach(function (b) {
        b.addEventListener('click', function () { self.change(b.getAttribute('data-line-remove'), 0); });
      });
      self.el.querySelectorAll('[data-line-qty]').forEach(function (inp) {
        inp.addEventListener('change', function () { self.change(inp.getAttribute('data-line-qty'), parseInt(inp.value, 10) || 0); });
      });
      self.el.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = b.parentNode.querySelector('input');
          var v = parseInt(inp.value, 10) || 1;
          v = b.hasAttribute('data-qty-plus') ? v + 1 : Math.max(0, v - 1);
          inp.value = v;
          inp.dispatchEvent(new Event('change'));
        });
      });
    },
    change: function (key, qty) {
      var self = this;
      self.el.classList.add('is-busy');
      return fetch(PS.routes.cartChange, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { return self.refresh(); })
        .finally(function () { self.el.classList.remove('is-busy'); });
    },
    add: function (formData) {
      var self = this;
      formData.append('sections', 'cart-drawer');
      return fetch(PS.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return self.refresh(); })
        .then(function () { self.open(); });
    }
  };

  function updateCounts(n) {
    n = parseInt(n, 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (el.hasAttribute('data-hide-empty')) el.hidden = n === 0;
    });
  }

  function initCart() {
    drawer.el = document.querySelector('[data-drawer]');
    if (!drawer.el) return;
    drawer.bind();
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); drawer.open(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.el.classList.contains('is-open')) drawer.close(); });
    // Cart page: same line controls, reload after change.
    var page = document.querySelector('[data-cart-page]');
    if (page) {
      page.querySelectorAll('[data-line-remove]').forEach(function (b) {
        b.addEventListener('click', function () { cartChangeReload(b.getAttribute('data-line-remove'), 0); });
      });
      page.querySelectorAll('[data-line-qty]').forEach(function (inp) {
        inp.addEventListener('change', function () { cartChangeReload(inp.getAttribute('data-line-qty'), parseInt(inp.value, 10) || 0); });
      });
      page.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = b.parentNode.querySelector('input');
          var v = parseInt(inp.value, 10) || 1;
          v = b.hasAttribute('data-qty-plus') ? v + 1 : Math.max(0, v - 1);
          inp.value = v; inp.dispatchEvent(new Event('change'));
        });
      });
    }
  }
  function cartChangeReload(key, qty) {
    fetch(PS.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function () { window.location.reload(); });
  }

  /* ------------------------------------------------------------------
     4. Product form
  ------------------------------------------------------------------ */
  function money(cents) {
    var f = PS.moneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var vd = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, vd.replace('.', ','))
            .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  function initProduct() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      if (root.getAttribute('data-form-ready')) return;
      root.setAttribute('data-form-ready', '1');
      var variants = [];
      try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) { return; }
      var optionCount = parseInt(root.getAttribute('data-option-count'), 10) || 1;
      var sizeIndex = parseInt(root.getAttribute('data-size-index'), 10); // -1 when no Size option
      var selected = [];
      var groups = root.querySelectorAll('[data-option-group]');
      groups.forEach(function (g, i) {
        var active = g.querySelector('.is-active');
        selected[i] = active ? active.getAttribute('data-value') : null;
      });
      if (!groups.length && variants.length) selected = variants[0].options.slice();
      var idInput = root.querySelector('[name="id"]');
      var addBtn = root.querySelector('[data-add]');
      var err = root.querySelector('[data-size-error]');
      var priceEl = root.querySelector('[data-price]');
      var wasEl = root.querySelector('[data-was]');
      var skuEl = root.querySelector('[data-sku]');
      var gallery = root.closest('[data-product]') || document;
      var mainImg = gallery.querySelector('[data-main-image]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');

      function findVariant() {
        for (var k = 0; k < variants.length; k++) {
          var v = variants[k], ok = true;
          for (var i = 0; i < optionCount; i++) { if (selected[i] !== v.options[i]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function refreshAvailability() {
        groups.forEach(function (g, gi) {
          g.querySelectorAll('[data-value]').forEach(function (btn) {
            var val = btn.getAttribute('data-value');
            var possible = variants.some(function (v) {
              if (v.options[gi] !== val) return false;
              for (var i = 0; i < optionCount; i++) { if (i !== gi && selected[i] && selected[i] !== v.options[i]) return false; }
              return v.available;
            });
            btn.classList.toggle('is-soldout', !possible);
          });
        });
      }
      function update() {
        var complete = selected.every(function (s) { return s !== null && s !== undefined; });
        var v = complete ? findVariant() : null;
        if (v) {
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (wasEl) { if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.hidden = false; } else { wasEl.hidden = true; } }
          if (skuEl && v.sku) skuEl.textContent = v.sku;
          if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-sold'); }
          if (v.featured_media_id && mainImg) {
            thumbs.forEach(function (t) {
              if (t.getAttribute('data-media-id') === String(v.featured_media_id)) t.click();
            });
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        } else if (complete && addBtn) {
          addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-unavail');
        } else if (addBtn) {
          addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label-add');
        }
        refreshAvailability();
      }
      groups.forEach(function (g, gi) {
        g.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            g.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
            selected[gi] = btn.getAttribute('data-value');
            if (err) err.hidden = true;
            update();
          });
        });
      });
      // Qty stepper
      var qty = root.querySelector('[data-qty-input]');
      root.querySelectorAll('[data-qty-dec],[data-qty-inc]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = b.hasAttribute('data-qty-inc') ? v + 1 : Math.max(1, v - 1);
        });
      });
      // Thumbs
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (mainImg) { mainImg.src = t.getAttribute('data-src'); mainImg.srcset = t.getAttribute('data-srcset') || ''; mainImg.alt = t.getAttribute('data-alt') || ''; }
        });
      });
      // Submit
      root.addEventListener('submit', function (e) {
        if (sizeIndex >= 0 && !selected[sizeIndex]) {
          e.preventDefault();
          if (err) { err.hidden = false; }
          var g = groups[sizeIndex]; if (g) g.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
          return;
        }
        if (!drawer.el) return; // fall back to normal POST
        e.preventDefault();
        var fd = new FormData(root);
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = '…'; }
        drawer.add(fd).catch(function (j) {
          alert((j && (j.description || j.message)) || 'Could not add to cart.');
        }).finally(function () { if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label-add'); } });
      });
      // Size validation also gates the dynamic checkout button.
      var buyNow = root.querySelector('[data-buy-now]');
      if (buyNow && sizeIndex >= 0) {
        buyNow.addEventListener('click', function (e) {
          if (!selected[sizeIndex]) { e.preventDefault(); e.stopPropagation(); if (err) err.hidden = false; }
        }, true);
      }
      update();
    });

    // Tabs
    document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      if (tabs.getAttribute('data-tabs-ready')) return;
      tabs.setAttribute('data-tabs-ready', '1');
      var btns = Array.prototype.slice.call(tabs.querySelectorAll('[data-tab]'));
      var panels = Array.prototype.slice.call(document.querySelectorAll('[data-tabpanel]'));
      // role="tab" without ids, aria-controls and roving tabindex is incomplete ARIA;
      // wire the relationships here so the markup stays simple.
      btns.forEach(function (b) {
        var key = b.getAttribute('data-tab');
        var panel = panels.filter(function (p) { return p.getAttribute('data-tabpanel') === key; })[0];
        if (!b.id) b.id = 'ps-tab-' + key;
        if (panel) {
          if (!panel.id) panel.id = 'ps-tabpanel-' + key;
          b.setAttribute('aria-controls', panel.id);
          panel.setAttribute('aria-labelledby', b.id);
          panel.setAttribute('tabindex', '0');
        }
        b.setAttribute('tabindex', b.classList.contains('is-active') ? '0' : '-1');
      });
      var select = function (b, moveFocus) {
        btns.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-tabpanel') !== b.getAttribute('data-tab'); });
        if (moveFocus) b.focus();
      };
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b, false); });
        b.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = btns[(i + 1) % btns.length];
          else if (e.key === 'ArrowLeft') next = btns[(i - 1 + btns.length) % btns.length];
          else if (e.key === 'Home') next = btns[0];
          else if (e.key === 'End') next = btns[btns.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     5. Collection: load more (Section Rendering API), filter drawer, sort
  ------------------------------------------------------------------ */
  function initCollection() {
    var more = document.querySelector('[data-load-more]');
    if (more && !more.getAttribute('data-more-ready')) {
      more.setAttribute('data-more-ready', '1');
      more.addEventListener('click', function () {
        var next = more.getAttribute('data-next');
        var sectionId = more.getAttribute('data-section');
        if (!next) return;
        var wrap = more.closest('[data-more-wrap]'); if (wrap) wrap.classList.add('is-loading');
        var url = new URL(next, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        fetch(url.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var grid = document.querySelector('[data-product-grid]');
          var newGrid = tmp.querySelector('[data-product-grid]');
          if (grid && newGrid) { while (newGrid.firstChild) grid.appendChild(newGrid.firstChild); }
          var newMore = tmp.querySelector('[data-load-more]');
          if (newMore && newMore.getAttribute('data-next')) { more.setAttribute('data-next', newMore.getAttribute('data-next')); }
          else if (wrap) { wrap.hidden = true; }
          history.replaceState({}, '', next);
        }).finally(function () { if (wrap) wrap.classList.remove('is-loading'); });
      });
    }
    var sort = document.querySelector('[data-sort]');
    if (sort && !sort.getAttribute('data-sort-ready')) {
      sort.setAttribute('data-sort-ready', '1');
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    var filters = document.querySelector('[data-filters]');
    if (filters && !filters.getAttribute('data-filters-ready')) {
      filters.setAttribute('data-filters-ready', '1');
      var fLast = null, fRelease = null;
      var openF = function () {
        fLast = document.activeElement;
        filters.classList.add('is-open');
        filters.setAttribute('aria-modal', 'true');
        filters.setAttribute('role', 'dialog');
        document.body.style.overflow = 'hidden';
        fRelease = trapFocus(filters);
        var c = filters.querySelector('[data-filters-close]'); if (c) c.focus();
      };
      var closeF = function () {
        filters.classList.remove('is-open');
        filters.removeAttribute('aria-modal');
        filters.removeAttribute('role');
        document.body.style.overflow = '';
        if (fRelease) { fRelease(); fRelease = null; }
        if (fLast && fLast.focus) fLast.focus();
        fLast = null;
      };
      document.querySelectorAll('[data-filters-open]').forEach(function (b) { b.addEventListener('click', openF); });
      filters.querySelectorAll('[data-filters-close]').forEach(function (b) { b.addEventListener('click', closeF); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && filters.classList.contains('is-open')) closeF();
      });
      var form = filters.querySelector('form');
      if (form) form.querySelectorAll('input[type=checkbox]').forEach(function (c) { c.addEventListener('change', function () { form.submit(); }); });
    }
  }

  /* ------------------------------------------------------------------
     6. Newsletter (Shopify customer form posts normally; show inline state
        when we return with ?customer_posted=true)
  ------------------------------------------------------------------ */
  function initNewsletter() {
    var f = document.querySelector('[data-newsletter]');
    if (!f) return;
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      var ok = f.querySelector('[data-newsletter-ok]'); if (ok) ok.hidden = false;
      f.scrollIntoView({ block: 'center' });
    }
  }

  /* ------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------ */
  function boot() {
    document.querySelectorAll('[data-rotator]').forEach(registerRotator);
    paint();
    startClock();
    initNav();
    initCart();
    initProduct();
    initCollection();
    initNewsletter();
    // Print buttons: bound here so no template needs an inline onclick handler.
    document.querySelectorAll('[data-print]').forEach(function (b) {
      b.addEventListener('click', function () { window.print(); });
    });
    // Search inputs: Enter submits to /search?q=
    document.querySelectorAll('[data-search-input]').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); window.location.href = PS.routes.search + '?q=' + encodeURIComponent(inp.value) + '&type=product'; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: re-register rotators when a section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-rotator]').forEach(registerRotator); paint(); initNav(); initProduct(); initCollection();
  });
})();
